import { breakpoints } from 'styles';
import { Box } from 'components/common/box';
import { PageSidebarNav } from '.';

import type { NavLinkOrSubheading } from 'types';

interface Props {
  active: string;
  children?: React.ReactNode;
  childrenOnTop?: boolean;
  isWide?: boolean;
  links: NavLinkOrSubheading[];
  preserveBackReference?: boolean;
}

const PageSidebar = ({
  active,
  children,
  childrenOnTop = true,
  isWide,
  links,
  preserveBackReference = false
}: Props) => (
  <div className="sidebar">
    <Box padding={0}>
      {childrenOnTop ? children || null : null}

      <PageSidebarNav
        active={active}
        links={links}
        preserveBackReference={preserveBackReference}
      />

      {!childrenOnTop ? children || null : null}
    </Box>

    <style jsx>{`
      .sidebar {
        flex-shrink: 0;
        margin-bottom: 20px;
        width: 100%;
      }
      @media (min-width: ${breakpoints.medium}px) {
        .sidebar {
          margin-bottom: 0;
          margin-right: 20px;
          width: 220px;
        }
      }
      @media (min-width: ${breakpoints.large}px) {
        .sidebar {
          width: ${isWide ? '260px' : '220px'};
        }
      }
    `}</style>
  </div>
);

export default PageSidebar;
